/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Reducer for lifestyles module
 */

import type { HoodLifestyleScore } from '@zcode/bizos'
import { falseReducer, trueReducer } from '@zcode/reducers'
import type { CurrentSearch } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  DONE_FETCHING_LIFESTYLES,
  ERROR_FETCHING_LIFESTYLES,
  RECEIVE_LIFESTYLES,
  START_FETCHING_LIFESTYLES,
} from '../constants'
import { sortLifestyles } from '../utils/sortLifestyles'

type Actions = ExtractActions<Values<typeof actions>>

export const allowedList = [
  DONE_FETCHING_LIFESTYLES,
  ERROR_FETCHING_LIFESTYLES,
  RECEIVE_LIFESTYLES,
  START_FETCHING_LIFESTYLES,
] as const satisfies ReadonlyArray<Actions['type']>

export const hoodLifestylesReducer = combineReducers<CurrentSearch['hoodLifestyles'], Actions>({
  fetching: handleActions(
    {
      [START_FETCHING_LIFESTYLES]: trueReducer,
      [DONE_FETCHING_LIFESTYLES]: falseReducer,
      [ERROR_FETCHING_LIFESTYLES]: falseReducer,
    },
    false
  ),
  data: handleActions<CurrentSearch['hoodLifestyles']['data'], Actions>(
    {
      [RECEIVE_LIFESTYLES]: (state, { payload }) => {
        const { hoodLifestyles } = payload
        const sortedLifestyles = sortLifestyles([...hoodLifestyles])
        return sortedLifestyles
      },
    },
    [] as HoodLifestyleScore[]
  ),
})
